import { REDUX_CONSTANTS } from "../reduxConstants";

const initialState = {
    currentLocationData: {},
    selectedLocationData: {},
    citiesList: [],
    filteredCityList: [],
    forecastData: {}
};

export const locationReducer = (state = initialState, action) => {

    switch (action.type) {
        case REDUX_CONSTANTS.UPDATE_CURRENT_LOCATION:
            return {
                ...state,
                currentLocationData: action.payload
            };
        case REDUX_CONSTANTS.UPDATE_SELECTED_LOCATION:
            return {
                ...state,
                selectedLocationData: action.payload
            };
        case REDUX_CONSTANTS.UPDATE_CITIES_LIST:
            return {
                ...state,
                citiesList: action.payload
            };
        case REDUX_CONSTANTS.FILTER_CITIES_LIST:
            return {
                ...state,
                filteredCityList: action.payload
            };
        case REDUX_CONSTANTS.UPDATE_FORECAST_DATA:
            return {
                ...state,
                forecastData: action.payload
            }
        default:
            return state;
    }
};
